import styled from 'styled-components'

export const PageContainer = styled.div`
    .Mui-disabled {
        color: #5d5d5d;
    }
`

// TO DO: remover esse container quando não utilizarmos mais o material ui
